import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss']
})
export class ConfirmDeleteComponent implements OnInit {
  onDataReceived = new EventEmitter()

  constructor(public dialogRef: MatDialogRef<ConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.data.description = this.data.description
     }

  ngOnInit(): void {
  }

  onClickYes(){
    this.dialogRef.close();
    this.onDataReceived.emit(true);
  }
  
  onClickNo(): void {
    this.dialogRef.close();
    this.onDataReceived.emit(false);
  }
  closeDialog():void{
    this.dialogRef.close();
  }
  


}
